import { Flex, InputField, SearchSelect, TextInputFieldProps, useSelectSingle } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

type AddressFormProps = {
  disabled?: boolean;
  coStreetAddressInput: TextInputFieldProps;
  streetAddressInput: TextInputFieldProps;
  streetAddress2Input: TextInputFieldProps;
  postalCodeInput: TextInputFieldProps;
  cityInput: TextInputFieldProps;
  countryInput: ReturnType<typeof useSelectSingle>['props'];
  isForeign: boolean;
  countriesOptions: { id: string; name: string }[];
};
export const AddressForm = ({
  disabled,
  streetAddressInput,
  streetAddress2Input,
  coStreetAddressInput,
  postalCodeInput,
  cityInput,
  countryInput,
  isForeign,
  countriesOptions,
}: AddressFormProps) => {
  const { t } = useTypedTranslation();

  return (
    <Flex flexDirection="column" rowGap={20} width={['100%', 349, 349]} backgroundColor="white">
      <SearchSelect
        {...countryInput}
        options={countriesOptions}
        label={t('form.editEmployee.countryLabel')}
        disabled={disabled}
        testId="test-country-select"
        searchPlaceholder={t('common.searchShortLabel')}
      />
      <InputField {...coStreetAddressInput} id="co-adress" label={t('form.editEmployee.coLabel')} disabled={disabled} />
      <InputField
        {...streetAddressInput}
        id="street-adress"
        label={isForeign ? t('form.editEmployee.streetAddressBoxLabel') : t('form.editEmployee.streetAddress1Label')}
        disabled={disabled}
      />
      <InputField
        {...streetAddress2Input}
        id="street-adress-2"
        label={isForeign ? t('form.editEmployee.streetAddressBoxLabel') : t('form.editEmployee.streetAddress2Label')}
        disabled={disabled}
      />
      <InputField
        {...postalCodeInput}
        id="postal-code"
        label={t('form.editEmployee.postalCodeLabel')}
        disabled={disabled}
      />
      <InputField {...cityInput} id="city" label={t('form.editEmployee.cityLabel')} disabled={disabled} />
    </Flex>
  );
};
